import script from "./InsightsContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./InsightsContainer.vue?vue&type=script&setup=true&lang=js"

import "./InsightsContainer.vue?vue&type=style&index=0&id=bb6ac4c0&lang=scss&scoped=true"

import exportComponent from "/home/viction/eshopcommand/source/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb6ac4c0"]])

export default __exports__